<template>
    <div>
        
    </div>
</template>
<script>

    import api from "../../config/_api";
    
    
    import {AUTH_LOGOUT} from '../../store/actions/auth';

    export default {
            name: "validerMonAdressMail",
            data (){
                return {
                    token : "",
                    tokenExist : null,
                    msgerror : "",
                    error : false,

                }
            },
            created() {
                this.token=this.$route.params.token;
                this.findToken();
            },
            methods:{
                findToken(){
                    this.axios({url: api.url + 'password/find/'+this.token,method: 'GET' })
                    .then(result => {
                        this.error=false;
                        this.tokenExist=true;
                        this.validateEmail();
                    }, error => {
                        this.error=true;
                        this.tokenExist=false;
                        this.msgerror=error;
                        this.redirection();
                    });
            },
            validateEmail(){
                     this.axios({url: api.url + "MailValidation/"+this.token,method: 'POST' })
                    .then(result => {
                        this.error=false;
                        this.tokenExist=true;
                        this.redirection();
                    }, error => {
                        this.error=true;
                        this.tokenExist=false;
                        this.msgerror=error;
                        this.redirection();
                    });
                
                
            },
            redirection(){
                if(this.$store.getters.getProfile.id){
                                this.$router.push({path:'/dashboard'});
                            }
                            else{
                                this.$router.push({path:'/login'});
                                }
            }
            }
        }
</script>
